<script>
  import options from './StickyContactCard.options'
  const componentOptions = options
  export default componentOptions
</script>

<template>

      <article
        class="be-sticky-contact-card be-js--sticky-contact-card"
        :data-content-name="labels?.matomoTrackingName ? labels?.matomoTrackingName : ''"
        :class="{ 'be-sticky-contact-card--no-image' : !labels?.imageSrc, 'matomo-tracking-class' : labels?.matomoTrackingName}"
          @click="scrollToContactCardList()">
          <template v-if="labels?.imageSrc">
            <figure class="be-image be-image--no-border-radius be-image--4-5">
              
              <div class="be-image__image-wrapper">
                <picture class="be-image__img">
                  <img :src="labels.imageSrc" :alt="labels?.imageAlt">
                </picture>
              </div>
              
            </figure>
          </template>
          <div class="be-sticky-contact-card__content-wrapper be-color-theme--yellow-yellow">
            <p class="be-font-paragraph-2">{{labels.title}}</p>
            <div class="be-sticky-contact-card__icon-wrapper">
  
              <div class="be-icon">
                <svg viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(#a)"><path d="M5.5 4h4l2 5L9 10.5a11 11 0 0 0 5 5l1.5-2.5 5 2v4a2 2 0 0 1-2 2 16 16 0 0 1-15-15 2 2 0 0 1 2-2" stroke="#8F5D18" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></g><defs><clipPath id="a"><path fill="#fff" transform="translate(.5)" d="M0 0h24v24H0z"/></clipPath></defs></svg>
              </div>
              <div class="be-icon">
                <svg viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(#a)" stroke="#8F5D18" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M19.5 5h-14a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2Z"/><path d="m3.5 7 9 6 9-6"/></g><defs><clipPath id="a"><path fill="#fff" transform="translate(.5)" d="M0 0h24v24H0z"/></clipPath></defs></svg>
              </div>
  
            </div>
          </div>

      </article>

</template>
